<script setup>
import DealerCard from './DealerCard.vue';

defineProps({
	dealers: { type: Array, default: () => [] },
	isLoading: { type: Boolean, default: false },
});

const emit = defineEmits(['select', 'view-details']);
</script>

<template>
	<div class="dealer-locator__list" aria-live="polite">
		<template v-if="isLoading">
			<div v-for="n in 4" :key="n" class="dealer-card dealer-card--skeleton" aria-hidden="true">
				<span class="dealer-card__skeleton-line dealer-card__skeleton-line--title"></span>
				<span class="dealer-card__skeleton-line dealer-card__skeleton-line--text"></span>
				<span class="dealer-card__skeleton-line dealer-card__skeleton-line--text"></span>
			</div>
		</template>

		<template v-else>
			<DealerCard v-for="dealer in dealers" :key="dealer.id" :dealer="dealer"
				@view-details="emit('view-details', $event)" />
		</template>
	</div>
</template>
